import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { InvoicesApi } from "@freightsimple/generated-dashboard-openapi-client/apis/InvoicesApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useInvoicesApi(): InvoicesApi {
  const { accessToken } = useAuthentication();

  return new InvoicesApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
